export default "__VITE_ASSET__DfjSr1xa__"